import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import pluralize from 'pluralize';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const Since = props => {
    dayjs.extend(relativeTime);
    pluralize.addIrregularRule('schema', 'schemas');
    dayjs.updateLocale('en', {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: 'a few seconds',
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      })

    const theme = useTheme();

    const type = pluralize(props.type || '');
    let lastUpdated = useSelector(state => (state[type] || {}).lastUpdated);
    lastUpdated = props.lastUpdated ? props.lastUpdated : lastUpdated
    const [since, setSince] = useState(dayjs(lastUpdated).fromNow());
    const seconds = 60;

    useEffect(() => {
        const interval = setInterval(() => {
            setSince(dayjs(lastUpdated).fromNow())
        }, seconds * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setSince(dayjs(lastUpdated).fromNow())
    }, [lastUpdated])

    // const color = lastUpdated && (dayjs().diff(lastUpdated, 'hour'))
    const hours = !props.lastUpdated && lastUpdated && (dayjs().diff(lastUpdated, 'hour'))
    const color = theme.palette[
        hours > 48 ? "error" : hours > 24 ? "secondary" : "neutral"
    ].main

    return (
        <Typography sx={{
            fontSize: '0.75rem',
            color: color
        }}>
            Last updated {since}
        </Typography>
    )
}
export default Since;